import React, { useState } from "react";
import { ComplianceLabel } from "./compliance_label";
import { EditNameModal } from "./edit_name_modal";
import { useSelector } from "react-redux";
import { EditAlertModal } from "./edit_alert_modal";
import { useMoveToLeagueMutation } from "../api/courses";
import { showErrorNotification, showNotification } from "../../shared/helpers";

export const Course = ({course}) => {
  const [courseChecked, setCourseChecked] = useState(course.isChecked)
  const [actionsOpen, setActionsOpen] = useState(false)
  const [showNameModal, setShowNameModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)

  const MRLeague = useSelector((state) => state.misc.data.MRLeague)
  const [ moveToLeague ] = useMoveToLeagueMutation()

  const handleCheck = async () => {
    const checked = !courseChecked
    setCourseChecked(!courseChecked)

    try {
      await moveToLeague({url: course.moveToLeagueUrl, checked: checked}).unwrap()
      showNotification(window.I18n.t('courses.course_updated_successfully'))
    } catch (error) {
      showErrorNotification(window.I18n.t('courses.failed_copy_course'))
    }
}

  const handleEditClick = () => {
    setShowEditModal(!showEditModal)
  }

  const ActionsColumn = () => {
    if(course.softDeleted)
      return(
        <a href={course.unarchiveUrl} className="btsp_small_white_button">
          <i class='gga-arrow-round-right add_margin-right-5'/>
          {window.I18n.t('courses.bootstrap_archived_course_table.restore')}
        </a>
      )
    else if(MRLeague)
      return(
        <div className={'dropMenu dropdown ' + (actionsOpen ? 'open' : '')} onClick={() => setActionsOpen(!actionsOpen)}>
          <a className='btn btn-default btn-xs new_dropdown_button_icon'>
            <i className={'fa fa-lg ' + (actionsOpen ? 'fa-caret-up' : 'fa-caret-down') }/>
          </a>
          <ul className='dropdown-menu'>
            <li>
              <a href='#' onClick={handleEditClick}>
                <i className="gga-pencil-45-angle add-margin-right-5"/>
                {window.I18n.t('courses.edit')}
              </a>
            </li>
            <li>
              <a href={course.checkComplianceUrl}>
                <i className="gga-custom-field add-margin-right-5"/>
                {window.I18n.t('courses.bootstrap_course_table_data.check_compliance')}
              </a>
            </li>
            <li>
              <a onClick={() => setShowNameModal(true)}>
                <i className="gga-custom-field add-margin-right-5"/>
                {window.I18n.t('courses.bootstrap_course_table_data.rename')}
              </a>
            </li>
            <li>
              <a href={course.archiveUrl}>
                <i className="gga-file-plus add-margin-right-5"/>
                {window.I18n.t('courses.bootstrap_course_table_data.archive')}
              </a>
            </li>
          </ul>
        </div>
      )
    else
      return(
      <>
        <a href='#' onClick={handleEditClick}>
          {window.I18n.t('courses.edit')}
        </a>
      </>)
  }
  return(
    <tr key={course.id}>
      <td className="check_col">
        <div
          className={`icheckbox_square-orange icheck-item icheck ${courseChecked ? 'checked' : ''}`}
          onClick={handleCheck}>
          <input
            type='checkbox'
            className={`i-checks icheck-input icheck ${courseChecked ? 'checked' : ''}`}
            checked={courseChecked}
          ></input>
        </div>
      </td>
      <td>{course.name}</td>
      <td>{course.city} {course.state}</td>
      <td><ComplianceLabel course={course}/></td>
      <td>{course.nameAbbreviation}</td>
      <td className="actions">
        <ActionsColumn/>
      </td>
      {showNameModal && <EditNameModal course={course} show={showNameModal} setShow={setShowNameModal}/>}
      {showEditModal && <EditAlertModal course={course} show={showEditModal} setShow={setShowEditModal}/>}
    </tr>
  )
}